import { type FC, useState, useEffect, useMemo } from "react";
import { Presentation } from "./Presentation";

type Props = {
  shopNames: string[];
  isSp: boolean;
};

const SP_INITIAL_COUNT = 3;
const SP_INCREMENT = 20;
const PC_INITIAL_COUNT = 9;
const PC_INCREMENT = 60;

export const SelectedShops: FC<Props> = ({ shopNames, isSp }) => {
  const { initialCount, increment } = useMemo(() => {
    return isSp
      ? { initialCount: SP_INITIAL_COUNT, increment: SP_INCREMENT }
      : { initialCount: PC_INITIAL_COUNT, increment: PC_INCREMENT };
  }, [isSp]);

  const [visibleCount, setVisibleCount] = useState(initialCount);

  useEffect(() => {
    setVisibleCount(initialCount);
  }, [initialCount]);

  const handleClickReadMore = () => {
    setVisibleCount((prev) => prev + increment);
  };

  const visibleShops = shopNames.slice(0, visibleCount);
  const showReadMoreButton = visibleCount < shopNames.length;

  return (
    <Presentation
      shopNames={visibleShops}
      onClickReadMore={handleClickReadMore}
      showReadMoreButton={showReadMoreButton}
    />
  );
};
